module.exports = __webpack_public_path__ + "static/2-234483f2a4495c53518a348c8077ae4f.jpg";